import { render, staticRenderFns } from "./DoctorNotes.vue?vue&type=template&id=7750fa16&"
import script from "./DoctorNotes.vue?vue&type=script&lang=js&"
export * from "./DoctorNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports